import axios from 'axios';
import API_BASE_URL from './api';

export const fetchUserEvents = async ({ token, type, email, user_id, start, end, limit = 100, offset = 0 }) => {
  const params = {};
  if (type) params.type = type;
  if (email) params.email = email;
  if (user_id) params.user_id = user_id;
  if (start) params.start = start;
  if (end) params.end = end;
  params.limit = limit;
  params.offset = offset;
  const res = await axios.get(`${API_BASE_URL}/api/admin/user-events`, {
    params,
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const exportUserEventsCsv = async ({ token, type, email, user_id, start, end }) => {
  const params = {};
  if (type) params.type = type;
  if (email) params.email = email;
  if (user_id) params.user_id = user_id;
  if (start) params.start = start;
  if (end) params.end = end;
  const res = await axios.get(`${API_BASE_URL}/api/admin/user-events/export`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });
  return res.data;
};